<template>
    <div class="goodsbrand">
        <div class="contents">
            <goods-class-title :src="require('@/assets/images/brand.png')" :imgwidth="214" :margintop="128" :marginbottom="25"/>
        </div>

        <div class="contents brandlist" >
                <goods-brand-item v-for="(brand,index) in brandlist" :key="index" :brand="brand" :branditemright="((index+1)%6)==0?true:false" :brandLeft="index==6?true:false"/>
             <div class="clear"></div>             
        </div>
        <div class="clear"></div>
            
    </div>  
</template>

<script>
import GoodsBrandItem from './GoodsBrandItem.vue'
import GoodsClassTitle from './GoodsClassTitle.vue'
export default {
  data(){
    return {
        brandlist:{}
    }
  },
  components: { GoodsClassTitle, GoodsBrandItem },
  methods:{
      articleitemData() {
        this.$api.index.getIndexBrand().then((res)=>{ 
            this.brandlist = res.data.datas
        })
      }
    //   async articleitemData() {
    //         const res = await this.$http.post('/brand')
    //         this.brandlist = res.data.data.list
    //     },
  },
  mounted(){
      this.articleitemData();
  }
}
</script>

<style  scoped>

    .goodsbrand{
        background: url("/static/brandbackground.png") no-repeat;
        background-size: 100% 100%;
        overflow: hidden;
    }
    .contents.brandlist{
        margin-bottom: 145px;
    }
</style>


// WEBPACK FOOTER //
// src/components/index/GoodsBrand.vue